const TaxTableArray = [
  {"salary": 10000, "federal": 0,     "fica": 765,   "taxRate": 0.076},
  {"salary": 11000, "federal": 0,     "fica": 842,   "taxRate": 0.077},
  {"salary": 12000, "federal": 0,     "fica": 918,   "taxRate": 0.077},
  {"salary": 13000, "federal": 60,    "fica": 995,   "taxRate": 0.081},
  {"salary": 14000, "federal": 160,   "fica": 1071,  "taxRate": 0.088},
  {"salary": 15000, "federal": 260,   "fica": 1148,  "taxRate": 0.094},
  {"salary": 16000, "federal": 360,   "fica": 1224,  "taxRate": 0.099},
  {"salary": 17000, "federal": 460,   "fica": 1301,  "taxRate": 0.103},
  {"salary": 18000, "federal": 560,   "fica": 1377,  "taxRate": 0.108},
  {"salary": 19000, "federal": 660,   "fica": 1454,  "taxRate": 0.111},
  {"salary": 20000, "federal": 760,   "fica": 1530,  "taxRate": 0.115},
  {"salary": 25000, "federal": 1315,  "fica": 1913,  "taxRate": 0.129},
  {"salary": 30000, "federal": 1915,  "fica": 2295,  "taxRate": 0.141},
  {"salary": 35000, "federal": 2515,  "fica": 2678,  "taxRate": 0.149},
  {"salary": 40000, "federal": 3115,  "fica": 3060,  "taxRate": 0.155},
  {"salary": 45000, "federal": 3715,  "fica": 3443,  "taxRate": 0.159},
  {"salary": 50000, "federal": 4315,  "fica": 3825,  "taxRate": 0.163},
  {"salary": 55000, "federal": 5162,  "fica": 4208,  "taxRate": 0.170},
  {"salary": 60000, "federal": 6262,  "fica": 4590,  "taxRate": 0.181},
  {"salary": 65000, "federal": 7362,  "fica": 4973,  "taxRate": 0.190},
  {"salary": 70000, "federal": 8462,  "fica": 5355,  "taxRate": 0.197},
  {"salary": 75000, "federal": 9562,  "fica": 5738,  "taxRate": 0.204},
  {"salary": 80000, "federal": 10662, "fica": 6120,  "taxRate": 0.210},
  {"salary": 85000, "federal": 11762, "fica": 6503,  "taxRate": 0.215},
  {"salary": 90000, "federal": 12862, "fica": 6885,  "taxRate": 0.219},
  {"salary": 95000, "federal": 13962, "fica": 7268,  "taxRate": 0.223},
  {"salary": 100000,"federal": 15104, "fica": 7650,  "taxRate": 0.228},
  {"salary": 105000,"federal": 16304, "fica": 8033,  "taxRate": 0.232},
  {"salary": 110000,"federal": 17504, "fica": 8415,  "taxRate": 0.236},
  {"salary": 115000,"federal": 18704, "fica": 8798,  "taxRate": 0.240},
  {"salary": 120000, "federal": 19904, "fica": 9180, "taxRate": 0.244},
  {"salary": 125000, "federal": 21104, "fica": 9563, "taxRate": 0.248},
  {"salary": 130000, "federal": 22304, "fica": 9945, "taxRate": 0.252},
  {"salary": 135000, "federal": 23504, "fica": 10328, "taxRate": 0.256},
  {"salary": 140000, "federal": 24704, "fica": 10710, "taxRate": 0.260},
  {"salary": 145000, "federal": 25904, "fica": 11093, "taxRate": 0.264},
  {"salary": 150000, "federal": 27104, "fica": 11475, "taxRate": 0.268},
  {"salary": 155000, "federal": 28304, "fica": 11858, "taxRate": 0.272},
  {"salary": 160000, "federal": 29504, "fica": 12240, "taxRate": 0.276},
  {"salary": 165000, "federal": 30704, "fica": 12623, "taxRate": 0.280},
  {"salary": 170000, "federal": 31904, "fica": 12989, "taxRate": 0.284},
  {"salary": 175000, "federal": 33104, "fica": 12899.90, "taxRate": 0.288},
  {"salary": 180000, "federal": 34304, "fica": 12899.90, "taxRate": 0.292},
  {"salary": 185000, "federal": 35504, "fica": 12899.90, "taxRate": 0.296},
  {"salary": 190000, "federal": 36704, "fica": 12899.90, "taxRate": 0.300},
  {"salary": 195000, "federal": 37904, "fica": 12899.90, "taxRate": 0.304},
  {"salary": 200000, "federal": 39104, "fica": 12899.90, "taxRate": 0.308}

];

export default TaxTableArray   